import * as React from 'react';
/**
 *
 * Original name: person circle
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1054
 *
 */
export const PersonCircleLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Zm0 1.5c4.374 0 6.5 2.126 6.5 6.5a8.864 8.864 0 0 1-.475 3.053 4.271 4.271 0 0 0-3.125-1.542A4.817 4.817 0 0 0 15.5 11c0-2.542-1.275-4-3.5-4s-3.5 1.458-3.5 4a4.817 4.817 0 0 0 .6 2.511 4.221 4.221 0 0 0-3.128 1.533A8.878 8.878 0 0 1 5.5 12c0-4.374 2.126-6.5 6.5-6.5ZM10 11c0-2.216 1.069-2.5 2-2.5s2 .284 2 2.5-1.069 2.5-2 2.5-2-.284-2-2.5Zm2 7.5c-2.415 0-4.142-.65-5.207-1.97A2.731 2.731 0 0 1 9.25 15h5.5a2.763 2.763 0 0 1 2.457 1.53C16.142 17.85 14.415 18.5 12 18.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
